import GetWeather from '../getWeather';

const SEARCH_FORM_STYLE_CLASS = 'form-search';
const SEARCH_INPUT_STYLE_CLASS = 'form-search_input';
const SEARCH_INPUT_PLACEHOLDER_TEXT = 'Search for a city...';
const SEARCH_BUTTON_STYLE_CLASS = 'form-search__button';
const SEARCH_BUTTON_TEXT = 'Search';
const CONTROLL_AREA_STYLE_CLASS = 'control-area';
const BUTTON_REFRESH_STYLE_CLASS = 'button-refresh';
const REFRESH_ICON_STYLE_CLASS = 'button-refresh_icon';
const BUTTON_UNITS_STYLE_CLASS = 'button-units';
const BUTTON_CONTROLL_AREA_STYLE_CLASS = 'button-controll-area';
const BUTTON_UNITS_F_STYLE_CLASS = 'button-f';
const BUTTON_UNITS_C_STYLE_CLASS = 'button-c';
const LANGUAGE_SELECT_DROP_DOWN_CLASS = 'language-drop-down';

export default class SearchArea {
  createControlArea() {
    this.controlAreaArea = document.createElement('div');
    this.controlAreaArea.classList.add(CONTROLL_AREA_STYLE_CLASS);
    document.body.appendChild(this.controlAreaArea);
    this.createControlButtons(this.controlAreaArea);
    this.createForm(this.controlAreaArea);
  }

  createControlButtons(controlAreaArea) {
    this.buttonsControlArea = document.createElement('div');
    this.buttonsControlArea.classList.add(BUTTON_CONTROLL_AREA_STYLE_CLASS);

    this.buttonRefreshImg = document.createElement('div');
    this.buttonRefreshImg.classList.add(BUTTON_REFRESH_STYLE_CLASS);

    this.buttonRefreshImgIcon = document.createElement('div');
    this.buttonRefreshImgIcon.classList.add(REFRESH_ICON_STYLE_CLASS);

    this.buttonChengeUnitsTemp = document.createElement('div');
    this.buttonChengeUnitsTemp.classList.add(BUTTON_UNITS_STYLE_CLASS);

    this.buttonUnitsF = document.createElement('div');
    this.buttonUnitsF.classList.add(BUTTON_UNITS_F_STYLE_CLASS);
    this.buttonUnitsF.innerText = 'F';

    this.buttonUnitsC = document.createElement('div');
    this.buttonUnitsC.classList.add(BUTTON_UNITS_C_STYLE_CLASS);
    this.buttonUnitsC.innerText = 'C';

    this.buttonUnitsC = document.createElement('div');
    this.buttonUnitsC.classList.add(BUTTON_UNITS_C_STYLE_CLASS);
    this.buttonUnitsC.innerText = 'C';

    this.selectChangeLanguage = document.createElement('select');
    this.selectChangeLanguage.classList.add(LANGUAGE_SELECT_DROP_DOWN_CLASS);
    this.optionLanguageEn = document.createElement('option');
    this.optionLanguageEn.classList.add('En');
    this.optionLanguageRu = document.createElement('option');
    this.optionLanguageRu.classList.add('Ru');
    this.optionLanguageBe = document.createElement('option');
    this.optionLanguageBe.classList.add('Be');

    this.selectChangeLanguage.appendChild(this.optionLanguageEn);
    this.selectChangeLanguage.appendChild(this.optionLanguageRu);
    this.selectChangeLanguage.appendChild(this.optionLanguageBe);

    this.buttonChengeUnitsTemp.appendChild(this.buttonUnitsF);
    this.buttonChengeUnitsTemp.appendChild(this.buttonUnitsC);
    this.buttonRefreshImg.appendChild(this.buttonRefreshImgIcon);
    this.buttonsControlArea.appendChild(this.buttonRefreshImg);
    this.buttonsControlArea.appendChild(this.buttonChengeUnitsTemp);
    this.buttonsControlArea.appendChild(this.selectChangeLanguage);
    controlAreaArea.appendChild(this.buttonsControlArea);
    this.addLanguageButton();
  }

  createForm(controlAreaArea) {
    this.form = document.createElement('form');
    this.form.classList.add(SEARCH_FORM_STYLE_CLASS);
    this.createSerchInput(this.form);
    this.createSerchButtonRequest(this.form);
    controlAreaArea.appendChild(this.form);
  }

  createSerchInput(form) {
    this.formInput = document.createElement('input');
    this.formInput.setAttribute('type', 'text');
    this.formInput.setAttribute('autofocus', '');
    this.formInput.setAttribute('placeholder', SEARCH_INPUT_PLACEHOLDER_TEXT);
    this.formInput.classList.add(SEARCH_INPUT_STYLE_CLASS);
    form.appendChild(this.formInput);
  }

  createSerchButtonRequest(form) {
    this.formButton = document.createElement('button');
    this.formButton.setAttribute('type', 'submit');
    this.formButton.classList.add(SEARCH_BUTTON_STYLE_CLASS);
    this.formButton.textContent = SEARCH_BUTTON_TEXT;
    form.appendChild(this.formButton);
  }

  addEventOnSerchButton() {
    document.querySelector(`.${SEARCH_BUTTON_STYLE_CLASS}`).addEventListener('click', async (buttonEvent) => {
      buttonEvent.preventDefault();
      this.getWeather(this.formInput.value);
    });
  }

  getWeather(query) {
    this.weather = new GetWeather();
    this.weather.getWeather(query);
  }

  init() {
    this.createControlArea();
    this.addEventOnSerchButton();
  }

  addLanguageButton() {
    this.language = 'En';
    document.querySelector('.En').innerText = 'En';
    document.querySelector('.Ru').innerText = 'Ru';
    document.querySelector('.Be').innerText = 'Be';
  }
}
